<template>
  <custom-dialog
    :widthDialog="'800px'"
    :classDialog="'create-dialog custome-dialog'"
    :offsetTop="'3vh'"
    :openDialog="isOpen"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">
        Thêm chặng bay
      </h5>
    </template>

    <template #body>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="150px"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Điểm đi" prop="airportFrom">
              <el-select
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="form.airportFrom"
                placeholder="Điểm đi"
                size="medium"
                filterable
                clearable
              >
                <el-option
                  v-for="item in airports"
                  :key="item.id"
                  :label="item.placeName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="Điểm đến" prop="airportTo">
              <el-select
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="form.airportTo"
                placeholder="Điểm đến"
                size="medium"
                filterable
                clearable
              >
                <el-option
                  v-for="item in airports"
                  :key="item.id"
                  :label="item.placeName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item
              label="Thời gian bay yêu cầu"
              prop="flightTimeEstimate"
            >
              <el-date-picker
                v-model="form.flightTimeEstimate"
                size="medium"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                type="datetime"
                placeholder="dd/MM/yyyy HH:mm"
                format="dd/MM/yyyy HH:mm"
                :prefix-icon="' '"
                :picker-options="flightTimeEstimatePickerOption"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__right">
        <el-button
          size="medium"
          type="success"
          class="addDocs  color__white bg__blue btn-none__border"
          @click="submit"
        >
          <i class="far fa-check-circle font-size__small"></i>
          {{ isEditMode ? "Lưu" : "Thêm" }}&nbsp;
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >Bỏ qua
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>
<script>
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import CustomDialog from "../../common/custom-dialog";
import hcCfgAirportService from "../../../services/maybay/hcCfgAirportService";
import moment from "moment";
import errorMessageFilter from "../../../filters/errorMessageFilter";

export default {
  name: "hc-maybay-add-route-dialog",
  mixins: [handleRequestErrorMixin],
  props: ["isOpen", "route"],
  components: {
    CustomDialog
  },
  data() {
    return {
      rules: {
        airportFrom: null,
        airportTo: null,
        flightTimeEstimate: null
      },
      form: {
        airportFrom: null,
        airportTo: null,
        flightTimeEstimate: null
      },
      airports: [],
      flightTimeEstimatePickerOption: {
        disabledDate: null
      }
    };
  },

  watch: {},
  computed: {
    isEditMode() {
      return !!this.route;
    }
  },

  created() {
    this.initPage();
    this.loadAirports();
    this.initValidationRules();
    if (this.isEditMode) this.initFormForEdit();
  },

  methods: {
    initFormForEdit() {
      this.form.airportFrom = this.route.airportFromId;
      this.form.airportTo = this.route.airportToId;
      this.form.flightTimeEstimate = this.route.flightTimeEstimate
        ? new Date(this.route.flightTimeEstimate)
        : null;
    },

    initPage() {
      this.flightTimeEstimatePickerOption.disabledDate = time =>
        !(
          time.getTime() >=
          new moment(new Date())
            .startOf("date")
            .toDate()
            .getTime()
        );
    },

    loadAirports() {
      return hcCfgAirportService
        .findAll()
        .then(response => (this.airports = response.data));
    },

    initValidationRules() {
      let defaultRequiredConstrains = {
        required: true,
        message: "Trường dữ liệu bắt buộc",
        trigger: "blur"
      };

      let flightTimeEstimateTimeValidator = (rule, value, callback) => {
        if (!value) return callback();
        if (value.getTime() < new Date().getTime())
          return callback(
            new Error("Thời gian bay yêu cầu không được nhỏ hơn hiện tại")
          );
        return callback();
      };

      this.rules.airportFrom = [defaultRequiredConstrains];
      this.rules.airportTo = [defaultRequiredConstrains];
      this.rules.flightTimeEstimate = [
        defaultRequiredConstrains,
        {validator: flightTimeEstimateTimeValidator, trigger: "blur"}
      ];
    },

    validateForm() {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          if (!valid) {
            this.$message.error("Có lỗi nhập liệu. Vui lòng kiểm tra lại");
          } else {
            resolve();
          }
        });
      });
    },

    validateFromToAirport() {
      return new Promise(resolve => {
        if (this.form.airportFrom === this.form.airportTo) {
          this.$message.error(
            errorMessageFilter({errorCode: "hcFlight.airport.duplicated"})
          );
        } else {
          resolve();
        }
      });
    },

    convertToSubmitForm() {
      return {
        airportFromId: this.form.airportFrom,
        airportToId: this.form.airportTo,
        flightTimeEstimate: this.form.flightTimeEstimate
          ? this.form.flightTimeEstimate.getTime()
          : null
      };
    },

    submit() {
      this.validateForm()
        .then(() => this.validateFromToAirport())
        .then(() => {
          this.$emit("submit", {result: this.convertToSubmitForm()});
        });
    }
  }
};
</script>

<style type="text/css" scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/vemaybay/hc-maybay-add-route-dialog.vue